import React, { useState, useEffect } from "react";
import {
    Button, Card, CardBody, Col, Container, Form, FormGroup, Input, InputGroup, Label, Row, FormFeedback,
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";
import Select from "react-select";
import Breadcrumb from "components/Common/Breadcrumb";
import withRouter from "components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { addNewBook, addNewNavigation, getSerts, updateNavigation } from "helpers/fakebackend_helper";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";


const NavigationCreate = () => {
    //meta title

    const router = useNavigate();

    const { state } = useLocation()
    const [isLoading, setisLoading] = useState(false)
    const [modal, setModal] = useState(false);
    const [Pre, setPre] = useState();
    const [iPre, setiPre] = useState();
    const [text, setText] = useState("");
    const [parent, setParent] = useState(state?.parent);
    const [typeList, setTypeList] = useState([{ label: 'External Redirect', value: '1' }, { label: 'Template ', value: '2' }, { label: 'Dropdown', value: '3' },{ label: 'Internal Redirect', value: '4' } ])
    // const typeList = [{ label: 'External Redirect', value: '1' }, { label: 'Template ', value: '2' }, { label: 'Dropdown', value: '3' }]
    const typeLis2t = [{ label: 'Home', value: '1' }, { label: 'About-Us', value: '2' }, { label: 'Directorates', value: '3' }, { label: 'Magazine', value: '4' }, { label: 'ennum', value: '5' }, { label: 'RTE', value: '6' }, { label: 'ACT & Codes', value: '7' }
        , { label: 'GOS', value: '8' }, { label: 'Press Release', value: '9' }, { label: 'Select Templete', value: '' }
    ]

    useEffect(() => {
        if (state?.parent) {
            setParent(state?.parent)
            setText(state?.parent?.tamil_name ?? '')
        }

        if(state?.parent?.parentName){
            setTypeList([{ label: 'External Redirect', value: '1' }, { label: 'Template ', value: '2' }, { label: 'Internal Redirect', value: '4' }])
        }
    }, [state])

    const toggle = () => {
        setModal(!modal);
    };

    useEffect(() => {
        if (!modal) {
            setiPre()
        }
    }, [modal])


    console.log('parentparent', parent);



    const NavFormik = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            parent_id: '',
            eng_name: parent?.eng_name ?? '',
            tamil_name: parent?.tamil_name ?? '',
            redirect_url: parent?.redirect_url ?? '',
            type: parent?.nav_type ?? '',
            order_by: parent?.order ?? '',
            template_type : parent?.template_type ?? '',
            tab : parent?.tab ?? ''
        },
        validationSchema: Yup.object().shape({
            eng_name: Yup.string().required("Enter English Title"),
            // tamil_name: Yup.string().required("Enter Tamil Title"),
            redirect_url: Yup.string(),
            type: Yup.string().required("Select Type"),
            order_by: Yup.string().required("Enter Order By"),
        }),
        onSubmit: (values, { setErrors, setFieldError }) => {

            if (values.type == 1 && !values.redirect_url) {
                return setFieldError('redirect_url', 'Enter Redirect Url')
            }

            if (values.type == 4 && !values.redirect_url) {
                return setFieldError('redirect_url', 'Enter Redirect Url')
            }

            if (text == '') {
                return toast.error('Please Enter Tamil title')
            }

            if (state?.isEdit) {
                const payload = {
                    navigation_id: parent?.id ?? null,
                    eng_name: values.eng_name,
                    tamil_name: text,
                    type: parseInt(values.type),
                    order_by: values.order_by,
                    // template_type : parseInt(values.template_type)
                }

                if(values.type == 2) {
                    payload['template_type'] = parseInt(values.template_type)
                }
                
                if(parent?.parentName) {
                    payload['parent_id'] = parent?.parentId
                }

                if (values.type == 1 || values.type == 4 ) {
                    payload['redirect_url'] = values.redirect_url;
                    payload['tab'] = values.tab
                }

                setisLoading(true)
                updateNavigation(payload).then(res => {
                    setisLoading(false)
                    if (res?.success) {
                        toast.success("update Success")
                        router(-1)
                    } else {
                        toast.error(res?.message ?? 'somthing went wrong!')
                    }
                }).catch(err => {
                    setisLoading(false)
                    toast.error(err.message)
                })
            } else {
                const payload = {
                    parent_id: parent?.id ?? null,
                    eng_name: values.eng_name,
                    tamil_name: text,
                    type: parseInt(values.type),
                    order_by: values.order_by,
                    template_type : parseInt(values.template_type),
                }

                if (values.type == 1 || values.type == 4) {
                    payload['redirect_url'] = values.redirect_url
                    payload['tab'] = values.tab
                }

                setisLoading(true)
                addNewNavigation(payload).then(res => {
                    setisLoading(false)
                    if (res?.success) {
                        toast.success("Added Success")
                        router(-1)
                    } else {
                        toast.error(res?.message ?? 'somthing went wrong!')
                    }
                }).catch(err => {
                    setisLoading(false)
                    toast.error(err.message)
                })
            }
        }
    });



    return (<>
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumb title="Navigation List" breadcrumbItem={parent?.parentName ?? "Navigation"} />
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <h4 className="card-title mb-3">{state?.isEdit ? "Update Navigation" : "Create Navigation"}</h4>
                                <form onSubmit={NavFormik.handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">English Title<span className="text-danger">*</span></Label>
                                                <Input
                                                    name="eng_name"
                                                    placeholder="English Title"
                                                    type="text"
                                                    onChange={NavFormik.handleChange}
                                                    onBlur={NavFormik.handleBlur}
                                                    value={NavFormik.values.eng_name || ""}
                                                    invalid={
                                                        NavFormik.touched.eng_name && NavFormik.errors.eng_name ? true : false
                                                    }
                                                />

                                                {NavFormik.touched.eng_name && NavFormik.errors.eng_name ? (
                                                    <FormFeedback type="invalid">{NavFormik.errors.eng_name}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Tamil Title<span className="text-danger">*</span></Label>
                                                <ReactTransliterate
                                                    value={text}
                                                    onChangeText={setText}
                                                    lang="ta" // Tamil Language
                                                    name="tamil_name"
                                                    // onBlur={NavFormik.handleBlur}
                                                    placeholder="Tamil Title"
                                                    style={{
                                                        width: "100%",
                                                        padding: "7px",
                                                        // fontSize: "16px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                    }}
                                                />
                                                {NavFormik.errors.tamil_name ? (
                                                    <FormFeedback type="invalid">{NavFormik.errors.tamil_name}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Order By<span className="text-danger">*</span></Label>
                                                <Input
                                                    name="order_by"
                                                    placeholder="Enter Order"
                                                    type="number"
                                                    onChange={NavFormik.handleChange}
                                                    onBlur={NavFormik.handleBlur}
                                                    value={NavFormik.values.order_by || ""}
                                                    invalid={
                                                        NavFormik.touched.order_by && NavFormik.errors.order_by ? true : false
                                                    }
                                                />

                                                {NavFormik.touched.order_by && NavFormik.errors.order_by ? (
                                                    <FormFeedback type="invalid">{NavFormik.errors.order_by}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Select Type<span className="text-danger">*</span></Label>
                                                <Select
                                                    placeholder="Select Type"
                                                    options={typeList}
                                                    value={typeList?.find(e => e?.value == NavFormik.getFieldProps('type').value)}
                                                    getOptionLabel={(e) => e?.label}
                                                    getOptionValue={(e) => e?.value}
                                                    onChange={(e) => { NavFormik.setFieldValue('type', e?.value) }}
                                                    className="select2-selection"
                                                />
                                                {NavFormik.touched.type && NavFormik.errors.type ? (
                                                    <p className="mb-0 text-danger mt-1" >{NavFormik.errors.type}</p>
                                                ) : null}
                                            </div>
                                        </Col>

                                        {
                                            NavFormik.getFieldProps('type').value == 1 || NavFormik.getFieldProps('type').value == 4 ?
                                                <Col md="6">
                                                    <div className="mb-3">
                                                        <Label className="form-label">Redirect Url<span className="text-danger">*</span></Label>
                                                        <Input
                                                            name="redirect_url"
                                                            placeholder="Enter Redirect"
                                                            type="text"
                                                            onChange={NavFormik.handleChange}
                                                            onBlur={NavFormik.handleBlur}
                                                            value={NavFormik.values.redirect_url || ""}
                                                            invalid={
                                                                NavFormik.touched.redirect_url && NavFormik.errors.redirect_url ? true : false
                                                            }
                                                        />

                                                        {NavFormik.touched.redirect_url && NavFormik.errors.redirect_url ? (
                                                            <FormFeedback type="invalid">{NavFormik.errors.redirect_url}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Col> : NavFormik.getFieldProps('type').value == 2 ?
                                                    <Col md="6">
                                                        <div className="mb-3">
                                                            <Label>Select Template<span className="text-danger">*</span></Label>
                                                            <Select
                                                                placeholder="Select Template"
                                                                options={typeLis2t}
                                                                value={typeLis2t?.find(e => e.value == NavFormik.getFieldProps('template_type').value)}
                                                                getOptionLabel={(e) => e?.label}
                                                                getOptionValue={(e) => e?.value}
                                                                onChange={(e) => { NavFormik.setFieldValue('template_type', e?.value) }}
                                                                className="select2-selection"
                                                            />
                                                            {/* {NavFormik.touched.type && NavFormik.errors.type ? (
                                                                <p className="mb-0 text-danger mt-1" >{NavFormik.errors.type}</p>
                                                            ) : null} */}
                                                        </div>
                                                    </Col>
                                                    : ''
                                        }

                                        {/* {
                                             NavFormik.getFieldProps('type').value == 1 ?
                                             <Col md="6">
                                             <div className="mb-3">
                                                 <Label>Select Mode</Label>
                                                 <Select
                                                     placeholder="Select mode"
                                                     options={[{label:'Current Tab', value:'0'},{label:'New Tab', value:'1'}]}
                                                     value={[{label:'Current Tab', value:'0'},{label:'New Tab', value:'1'}]?.find(e => e?.value == NavFormik.getFieldProps('tab').value)}
                                                     getOptionLabel={(e) => e?.label}
                                                     getOptionValue={(e) => e?.value}
                                                     onChange={(e) => { NavFormik.setFieldValue('tab', e?.value) }}
                                                     className="select2-selection"
                                                 />
                                                 {NavFormik.touched.tab && NavFormik.errors.tab ? (
                                                     <p className="mb-0 text-danger mt-1" >{NavFormik.errors.tab}</p>
                                                 ) : null}
                                             </div>
                                         </Col> : ''
                                        } */}



                                        <Col lg={12}>
                                            <div className="text-end mb-4">
                                                <Button disabled={isLoading} type="submit" color="primary">
                                                    {
                                                        isLoading ?
                                                            <>
                                                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                                Loading
                                                            </>
                                                            :
                                                            state?.isEdit ? "Update Navigation" : "Create Navigation"
                                                    }
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                        Preview
                    </ModalHeader>
                    <ModalBody>
                        {
                            iPre ?
                                <img src={iPre} style={{ width: '100%', height: '350px', objectFit: 'cover' }} className="preImh" />
                                : <iframe src={Pre} className="w-100" width="100%" height="400px"></iframe>
                        }
                    </ModalBody>
                </Modal>
            </Container>
        </div>
    </>)
}


export default withRouter(NavigationCreate);